import styled, { css } from 'styled-components';
import Markdown from 'react-markdown';

import { CARD_SHADOW_COLOR, WHITE, TOOLTIP_CONTENT_COLOR, UI_COLORS } from '../../utils/colors';
import { ContentContainer, ContentMain, ContentSide, sansSerifFont, serifFont } from '../layout/layout.styles';
import { media } from '../../utils/media';
import { ZINDEX } from '../../utils/constants';

const contentColorsStyles = ({ theme }) => css`
  background-color: ${theme.background};
  color: ${theme.color};
`;

export const NumberWrapper = styled.div`
  ${contentColorsStyles}
  width: 340px;
`

export const Card = styled.div`
  width: 340px;
`

export const NumberContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 30px 30px 10px;
`

export const Number = styled.h2`
  font-size: 120px;
  line-height: 120px;
  margin: 0;
`

export const Character = styled.h3`
  font-size: 80px;
  line-height: 90px;
  margin: 0;
`

export const Tooltip = styled.span`
  position: absolute;
  background-color: ${WHITE};
  padding: 10px 15px;
  margin-top: 5px;
  width: 300px;
  display: none;
  box-shadow: 0 2px 6px 0 ${CARD_SHADOW_COLOR};
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5em;
  z-index: ${ZINDEX.CONTENT_TOOLTIP};
  color: ${TOOLTIP_CONTENT_COLOR};
  ${sansSerifFont}
`;

export const Side = styled(ContentSide)``;

export const MarkdownContent = styled(Markdown)`
  h2 {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 120px;
    line-height: 120px;
    letter-spacing: -1.55714px;
    margin: 0 0 13px 0;
    padding: 0 30px 30px;
  }
  p {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    padding: 0 30px 30px;
  }
`;

export const Main = styled(ContentMain)`
  width: 100%;
  padding-right: 40px;
`;

export const Container = styled(ContentContainer)`
  position: relative;
  padding: 0 0 48px 0;
`;
